import React, { useCallback, useEffect, useState } from 'react'
import { Select, H4, Separator } from '@fs/zion-ui'
import { useQueryParams } from '@fs/zion-router'
import { removeDuplicatesByKey } from '../helpers'
import { useCountryContext } from '../../providers'
import { useOnce } from '../../hooks'

const getCountries = () => {
  const A = 65 // ASCII code for 'A'
  const Z = 90 // ASCII code for 'Z'

  const countryName = new Intl.DisplayNames(['en'], { type: 'region' })
  const countries = {}

  for (let i = A; i <= Z; i++) {
    for (let j = A; j <= Z; j++) {
      const code = String.fromCharCode(i) + String.fromCharCode(j)
      const name = countryName.of(code)

      // we send INTL a potential country code. If it is valid, it will return the
      // name of the country
      if (code !== name) {
        countries[code] = name
      }
    }
  }

  return countries
}

const CountrySelector = ({ paramKey, isOpen }) => {
  const { query, setQuery, removeQuery } = useQueryParams()
  const { setCountry, preferredCountry, loading } = useCountryContext()
  const [value, setValue] = useState()

  const onChange = useCallback(
    (e) => {
      const newValue = e.target.value
      setCountry(newValue)
      setValue(newValue)
      if (newValue) {
        setQuery({ [paramKey]: newValue })
      } else {
        removeQuery(paramKey)
      }
    },
    [paramKey, removeQuery, setCountry, setQuery]
  )

  const onOnce = useOnce()
  useEffect(() => {
    if (isOpen && !loading) {
      onOnce(() => {
        onChange({ target: { value: query[paramKey] || preferredCountry } })
      })
    }
  }, [isOpen, loading, onChange, onOnce, paramKey, preferredCountry, query])

  const countries = getCountries()
  const options = removeDuplicatesByKey(
    Object.entries(countries).map(([v, label]) => ({ value: v, label })),
    'label'
  ).sort((a, b) => a.label.localeCompare(b.label))

  return (
    <>
      <H4 size="H5">Country</H4>
      <Separator size="nano" />
      <Select label="Country" placeholder="Select a country" options={options} value={value} onChange={onChange} />
    </>
  )
}

export default CountrySelector
